/**
 * Featured Products Slider
 * Builds Swiper configuration from data attributes,
 * separating Swiper logic (JS) from template data (Liquid).
 */
(function () {
  function buildSwiperOptions(el) {
    var slideCount = parseInt(el.dataset.slideCount, 10) || 0;
    var spacingDesktop = parseInt(el.dataset.spacingDesktop, 10) || 0;
    var spacingMobile = parseInt(el.dataset.spacingMobile, 10) || 0;
    var autoplayDelay = parseInt(el.dataset.autoplayDelay, 10) || 0;

    var options = {
      swiperId: el.dataset.swiperId || "",
      swiperName: "featured-products",
      slideCount: slideCount,
      slidesPerView: 1,
      slidesPerViewTablet: 2,
      slidesPerViewDesktop: 4,
      spaceBetweenMobile: 0,
      spaceBetweenDesktop: spacingDesktop || 16,
      grabCursor: true,
      speed: 400
    };

    if (el.dataset.navPrev && el.dataset.navNext) {
      options.navigation = {
        prevEl: el.dataset.navPrev,
        nextEl: el.dataset.navNext
      };
    }

    if (autoplayDelay > 0) {
      options.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    return options;
  }

  function initFeaturedProductsSliders() {
    var sliders = document.querySelectorAll(
      '.section-featured-products swiper-component[data-swiper-name="featured-products"]'
    );

    sliders.forEach(function (el) {
      var options = buildSwiperOptions(el);

      // Set as JSON attribute and on the instance
      el.setAttribute("data-swiper-options", JSON.stringify(options));
      el.swiperOptions = options;

      // If Swiper already initialized with wrong/empty config, destroy and re-init
      if (el.swiper) {
        el.swiper.destroy(true, true);
        el.swiper = null;
        el.swiperInitialized = false;
        el.init();
      } else if (el.swiperInitialized) {
        // Was marked as initialized but no swiper instance — reset and retry
        el.swiperInitialized = false;
        el.init();
      }
    });
  }

  // Run on DOMContentLoaded (fires before 'load', before Swiper init)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFeaturedProductsSliders);
  } else {
    initFeaturedProductsSliders();
  }

  // Also run on load as a safety net
  window.addEventListener("load", initFeaturedProductsSliders);

  // Re-run on Shopify section events (theme editor)
  window.addEventListener("shopify:section:load", initFeaturedProductsSliders);
  window.addEventListener("shopify:section:select", initFeaturedProductsSliders);
})();
